module.exports = "/_next/static/images/user-icon-958d1a22cc3327dfd48bcd6b14ca3831.svg";